var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ds-form-item ds-neweditor", class: _vm.getCss },
    [
      _c(
        "div",
        { ref: "editorScroll" },
        [
          _vm.showLabel
            ? _c(
                "DsfFieldLabel",
                {
                  style: _vm.getLabelWidthStyle(),
                  attrs: {
                    mode: _vm.showDataCaptionMode,
                    "show-icon": _vm.showDataCaptionIcon,
                    trigger: _vm.showDataCaptionTrigger,
                    "data-caption": _vm.dataCapion,
                    "is-design": _vm.isDesign,
                    owner: _vm._self,
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t(_vm.label)) + " ")]
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "ds-form-block",
              style: _vm.getFormItemBlockMarginLeft(),
            },
            [
              _vm.showEditor && !(_vm.isDesign && _vm.readOnly)
                ? _c(
                    "div",
                    {
                      ref: "neweditorContent",
                      staticClass: "neweditor-content",
                      class: { "fix-toolbar": _vm.fixToolbar },
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.readOnly,
                              expression: "!readOnly",
                            },
                          ],
                          ref: "editorToolbar",
                          attrs: { id: "editor-toolbar" },
                        },
                        [
                          _c("div", {
                            attrs: { id: "toolbar-container_" + _vm.hash },
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "editor-container",
                          class: [
                            !_vm.isHideMenu
                              ? "float-catalog"
                              : _vm.catalogPos === "left"
                              ? "catalog-left"
                              : "catalog-right",
                          ],
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "editor-box",
                              class: { "full-width": !_vm.isShowSideBar },
                            },
                            [
                              _c("div", {
                                ref: "editorInput",
                                staticClass: "editor-input",
                                class: _vm.codeTheme,
                                style:
                                  _vm.resetWidth && _vm.resetWidth > 0
                                    ? _vm.returnResetWidth()
                                    : "",
                                attrs: { id: "editor-container_" + _vm.hash },
                                on: { click: _vm.handleClickInput },
                              }),
                              _vm.wordCount
                                ? _c("div", { staticClass: "wrod-msg" }, [
                                    _vm._v(_vm._s(_vm.msgCountTip)),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                          _vm.isShowSideBar
                            ? _c(
                                "div",
                                {
                                  ref: "editorSidebar",
                                  staticClass: "editor-sidebar",
                                  class: [
                                    !_vm.isHideMenu ? "float-catalog" : "",
                                    _vm.catalogPos === "left"
                                      ? "catalog-left"
                                      : "catalog-right",
                                    _vm.isHover ? "isHover" : "",
                                  ],
                                  style: _vm.setEditorSidebarPos(),
                                },
                                [
                                  _c("div", { staticClass: "compendium" }, [
                                    _c("span", { staticClass: "title" }, [
                                      _vm._v("大纲"),
                                    ]),
                                    _c(
                                      "span",
                                      { staticClass: "pithy" },
                                      [
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass: "item",
                                            attrs: {
                                              effect: "dark",
                                              content: _vm.isHideMenu
                                                ? "隐藏大纲"
                                                : "钉住大纲",
                                              placement: "top-start",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              class: _vm.isHideMenu
                                                ? "el-icon-unlock"
                                                : "el-icon-lock",
                                              on: { click: _vm.handleHideMenu },
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.isShowCloseTree(_vm.menuTree)
                                      ? _c(
                                          "span",
                                          { staticClass: "on-off" },
                                          [
                                            _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  effect: "dark",
                                                  content: _vm.isCloseAll
                                                    ? "全部展开"
                                                    : "全部折叠",
                                                  placement: "top-start",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  class: _vm.isCloseAll
                                                    ? "el-icon-caret-bottom"
                                                    : "el-icon-s-unfold",
                                                  on: {
                                                    click: _vm.isOpenOrClose,
                                                  },
                                                }),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "menu-tree-box" },
                                    [
                                      _c(
                                        "dsf-virtual-scroll",
                                        [
                                          _vm.menuTree.length > 0
                                            ? _c("el-tree", {
                                                ref: "menuTree",
                                                staticClass: "menu-tree",
                                                attrs: {
                                                  data: _vm.menuTree,
                                                  "current-node-key":
                                                    _vm.currentNodeKey,
                                                  "node-key": "id",
                                                  "default-expand-all":
                                                    _vm.isExpand,
                                                  "highlight-current": true,
                                                  "expand-on-click-node": false,
                                                },
                                                on: {
                                                  "node-click": _vm.nodeClick,
                                                  "node-expand": _vm.nodeExpand,
                                                  "node-collapse":
                                                    _vm.nodeCollapse,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var node = ref.node
                                                        var data = ref.data
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              class:
                                                                "tree-node-label el-tree-slot_padding-" +
                                                                data.indent,
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  node.label
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  1687266913
                                                ),
                                              })
                                            : _vm._e(),
                                          _vm.menuTree.length < 1 &&
                                          !_vm.readOnly
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "menu-placeholder",
                                                },
                                                [_vm._v("标题将在此展示")]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      !_vm.isHideMenu
                                        ? _c("img", {
                                            staticClass: "fix-icon",
                                            attrs: {
                                              src: require("_platform/assets/styles/themes/img/switch.png"),
                                              alt: "",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.isDesign && _vm.readOnly
                ? _c("div", {
                    class: _vm.ueditorCss,
                    attrs: { id: "designReadOnly" },
                    domProps: { textContent: _vm._s(_vm.msg) },
                  })
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }